import { currencySchema } from '~/features/internationalization/models/currency';
import { getViewerCurrency } from '~/features/internationalization/utils/get-viewer-currency';
import { useUserPreferences } from '~/features/user/hooks/use-user-preferences';
import { useClientRender } from '~/hooks/use-client-render';

function parsePreferredCurrency(value?: string) {
  const result = currencySchema.safeParse(value);
  return result.success ? result.data : null;
}

export function useCurrency() {
  const isClient = useClientRender();
  const { userPreferences, isLoading, isFetched } = useUserPreferences();
  const preferred = parsePreferredCurrency(userPreferences?.preferredCurrency);
  const currency = preferred ?? getViewerCurrency();
  const resolved = isClient && (isFetched || !isLoading);

  return { currency, resolved };
}
